import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Box,
  VStack,
  FormControl,
  FormLabel,
  Input,
  Button,
  Text,
  SimpleGrid,
  Menu,
  MenuButton,
  MenuList,
  MenuOptionGroup,
  MenuItemOption,
} from '@chakra-ui/react';

import { useColors } from './colors';

import { getSuppliersListApi } from 'features/suppliers/suppliers.api';

const StoreForm = ({ formData, onChange, onSubmit, selectedMarketplace }) => {
  const dispatch = useDispatch();

  const { list: supplierOptions, getSuppliersListStatus } = useSelector(
    (state) => state.suppliers,
  );

  useEffect(() => {
    dispatch(getSuppliersListApi());
  }, [dispatch]);

  const { backgroundCardColor, borderColor, textColor, inputBgColor, hoverBgColor } =
    useColors();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    onChange({ ...formData, [name]: value });
  };

  return (
    <Box
      flex={1}
      bg={backgroundCardColor}
      borderRadius="xl"
      p={8}
    >
      <Text fontSize="xl" fontWeight="semibold" mb={6} color={textColor}>
        Enter Store Details
      </Text>

      <form onSubmit={onSubmit}>
        <VStack spacing={6} align="stretch">
          <SimpleGrid columns={2} spacing={4}>
            <FormControl isRequired>
              <FormLabel color={textColor}>Store Name</FormLabel>
              <Input
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Enter store name"
                size="lg"
                color={textColor}
                bg={inputBgColor}
                borderColor={borderColor}
                _placeholder={{ color: 'gray.400' }}
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel color={textColor}>Store Username</FormLabel>
              <Input
                name="username"
                value={formData.username}
                onChange={handleInputChange}
                placeholder="Enter store username"
                size="lg"
                color={textColor}
                bg={inputBgColor}
                borderColor={borderColor}
                _placeholder={{ color: 'gray.400' }}
              />
            </FormControl>
          </SimpleGrid>

          <FormControl isRequired>
            <FormLabel color={textColor}>Select Suppliers</FormLabel>
            <Menu closeOnSelect={false}>
              <MenuButton
                as={Button}
                bg={inputBgColor}
                color={textColor}
                borderColor={borderColor}
                variant="outline"
                w={{ base: '100%', md: 'auto' }}
                size="lg"
                borderRadius="lg"
                minW="100%"
                isDisabled={getSuppliersListStatus === 'pending'}
                _hover={{
                  bg: hoverBgColor,
                }}
                _active={{
                  bg: hoverBgColor,
                }}
                _focus={{
                  bg: inputBgColor,
                  borderColor: 'blue.300',
                }}
                textAlign="left"
              >
                {formData?.suppliers?.length > 0
                  ? `${formData?.suppliers?.length} supplier${formData?.suppliers?.length > 1 ? 's' : ''}`
                  : 'Choose supplier(s)'}
              </MenuButton>

              <MenuList
                bg={backgroundCardColor}
                borderColor={borderColor}
                p={3}
                minWidth="200%"
                shadow="lg"
              >
                <MenuOptionGroup
                  title="Suppliers"
                  type="checkbox"
                  value={formData.suppliers}
                  onChange={(values) => {
                    const vals = Array.isArray(values) ? values : [values];
                    onChange({ ...formData, suppliers: vals });
                  }}
                  color={textColor}
                  fontSize="md"
                >
                  {supplierOptions.map((opt) => (
                    <MenuItemOption
                      fontSize="lg"
                      key={opt.value}
                      value={opt.value}
                      bg="transparent"
                      color={textColor}
                    >
                      {opt.label}
                    </MenuItemOption>
                  ))}
                </MenuOptionGroup>
              </MenuList>
            </Menu>
          </FormControl>

          <Button
            type="submit"
            colorScheme="blue"
            size="lg"
            isDisabled={!selectedMarketplace}
            mt={4}
          >
            Connect Store
          </Button>
        </VStack>
      </form>
    </Box>
  );
};

export default StoreForm;
